module.exports = __webpack_public_path__ + "static/img/bg-image.66a9ca3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyao/bg-image.jpg
// module id = vIIy
// module chunks = 1